import { render } from "./OneAppError.vue?vue&type=template&id=bf9eef40&ts=true&lang=pug"
import script from "./OneAppError.vue?vue&type=script&lang=ts"
export * from "./OneAppError.vue?vue&type=script&lang=ts"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__